import {
  AcceptanceSettings,
  AppUsageMonitor,
  DevelopmentSettings,
  ProductionSettings,
} from "@haskoning/usage-monitor-client";

import { msalInstance } from "@/msalAuthConfig";

const usageMonitorSettingsByMode = {
  acceptance: AcceptanceSettings,
  "local-development": DevelopmentSettings,
  production: ProductionSettings,
};

const usageMonitorSettings =
  usageMonitorSettingsByMode[import.meta.env.MODE as keyof typeof usageMonitorSettingsByMode] ?? DevelopmentSettings;

const loginRequest = {
  scopes: [usageMonitorSettings.appRegistration?.apiScope || import.meta.env.VITE_AZURE_AUDIENCE],
};

async function getAccessToken(): Promise<string> {
  try {
    const tokenResponse = await msalInstance.acquireTokenSilent(loginRequest);
    return tokenResponse.accessToken;
  } catch (error) {
    console.error("Silent token acquisition failed for usage monitor:", error);
    throw new Error("Failed to acquire usage monitor access token");
  }
}

export const usageMonitor = new AppUsageMonitor({
  applicationName: "Equation Excel Client",
  settings: usageMonitorSettings,
  authenticate: () => getAccessToken(),
});
